import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
export { type ClassValue } from "clsx";

/**
 * The React ecosystem has a lot of approaches on how to handle
 * CSS in JS -> conditional styling.
 * For me this is missing in angular and I have yet to see a nice solution, how
 * to manage multiple conditional styles in angular.
 *
 * The best approach I know from react is to use clsx to combine styles,
 * multiple style strings and even make them conditional. twMerge on the other
 * hand makes sure that different classes from different styles don't conflict * with eachother. the combination as "cn" comes from the project https://ui.shadcn.com
 * See here: https://github.com/shadcn-ui/ui/blob/259a9ff56acc44551eca2a36023b4101d42e42df/templates/next-template/lib/utils.ts#L4
 *
 * If this is an anti pattern, give me a heads up and explain a better way to me
 */

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
